// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2w76k","approved":"Status_approved__2R4mV","rejected":"Status_rejected__2uU-T","expired":"Status_expired__2oeHf","label":"Status_label__2-8eb"};